import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
import { MOCK_PERMISSIONS } from './auth.mock';
import { Nullable } from '@pin-up-global/common';
import { AccessData } from '@core/auth/auth.abstraction';

@Injectable()
export class AuthServiceMock {
  #permissionsService = inject(NgxPermissionsService);

  #isAuthorized$ = new BehaviorSubject(true);
  isAuthorized$ = this.#isAuthorized$.asObservable();

  constructor() {
    this.#permissionsService.loadPermissions(MOCK_PERMISSIONS);
  }

  refresh(): Observable<Nullable<Omit<AccessData, 'refresh'>>> {
    return of(null);
  }

  getAccessToken(): string | null {
    return null;
  }

  getRefreshToken(): string | null {
    return null;
  }
}
